import { axios ,axios2} from '@/lib/axios';
import { ApiResponse, RoleContent } from '@/types';

export type contentManagementDTO = {
  role_name: string;
  permission: any;
};

export const addRoles = (data: contentManagementDTO): Promise<ApiResponse<RoleContent>> => {
  return axios2.post('/admin-api/add-role', data);
};
